<template>
  <div style="background-color: #eee">
    <ArticleListCommentsDialog
      ref="articleCommentsDialog"
    ></ArticleListCommentsDialog>
    <!-- <ArticleLIstSharesDialog ref="articleSharesDialog" ></ArticleLIstSharesDialog> -->
    <v-row v-if="$vuetify.breakpoint.smAndUp">
      <!-- <pre>{{filteredArticles}}</pre> -->
      <v-col md="12">
        <v-row>
          <v-col md="6" v-for="item in filteredArticles" :key="item.id">
            <v-card class="mx-auto" max-width="600" outlined>
              <v-list-item three-line>
                <v-list-item-avatar
                  tile
                  size="150"
                  color="grey"
                  v-if="item.Media.length == 0"
                ></v-list-item-avatar>
                <v-list-item-avatar tile size="150" v-else>
                  <v-img :src="item.Media[0].s3url"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <p class="headline" style="display:flex;">
                    <span>{{ item.Title }} </span>

                    <!-- <span>Published{{item.Published}} -->
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mt-2"
                      text
                      @click="editArticle(item.id)"
                      :title="$t('yourArticles.card.Edit article')"
                    >
                      <v-icon large>far fa-edit</v-icon>
                    </v-btn>
                  </p>
                  <div>
                    <p class="subtitle-2 ma-0 pa-0 pb-2">
                      {{ $t("general.Published") }}
                      <span class="pr-6">
                        <v-icon color="green" v-if="item.Published == 1"
                          >far fa-check-square</v-icon
                        >
                        <v-icon color="error" v-else>far fa-square</v-icon>
                      </span>
                    </p>
                  </div>

                  <v-list-item-subtitle class="subtitle-2">{{
                    item.Created | moment("LL")
                  }}</v-list-item-subtitle>
                  <!-- <v-list-item-subtitle class="subtitle-2">{{ item.Created | moment('LL') }} </v-list-item-subtitle> -->
                  <v-list-item-subtitle class="subtitle-2"
                    >{{ $t("yourArticles.card.Category") }}:
                    {{ item.Category }}</v-list-item-subtitle
                  >
                  <v-divider></v-divider>
                  <v-row>
                    <v-col md="6">
                      <span class="pl-3 subtitle-1"
                        >{{ $t("yourArticles.card.Seen") }}:
                      </span>
                      <span class="pl-1 subtitle-1"
                        >{{ item.TotalViews }}
                      </span>
                      <span> {{ $t("yourArticles.card.Times") }}</span>
                    </v-col>
                    <v-col md="6">
                      <span class="pl-2 subtitle-1">{{
                        item.TotalComments
                      }}</span>
                      <!-- style="cursor: pointer;"
                        @click="$refs.articleCommentsDialog.openDialog(item)" -->
                      <span class="pl-1 subtitle-1">{{
                        $t("yourArticles.card.Comments")
                      }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--Phone-->
    <v-row v-else>
      <!--Take full screen-->
      <v-col
        cols="12"
        v-for="item in filteredArticles"
        :key="item.id"
        class="pl-8"
      >
        <v-card width="100%" outlined class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <!--Image-->
            <v-col cols="12" v-if="item.Media.length == 1" class="ma-0 pa-0">
              <img :src="item.Media[0].s3url" style="width: 100%" />
            </v-col>
            <!--If no image uploaded-->
            <v-col v-else cols="12">
              <p class="text-center">No image uploaded</p>
              <v-divider></v-divider>
            </v-col>
            <!--Title and edit-->
            <v-col cols="12" class="py-0">
              <v-row class="ma-0 pa-0">
                <!--Title-->
                <v-col cols="auto" class="pl-2 pb-0">
                  <p class="headline">{{ item.Title }}</p>
                </v-col>
                <v-spacer></v-spacer>
                <!--Edit-->
                <v-col cols="auto" class="pa-0">
                  <v-btn
                    class="mt-2"
                    text
                    @click="editArticle(item.id)"
                    :title="$t('yourArticles.card.Edit article')"
                  >
                    <v-icon large>far fa-edit</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!--Published-->
            <v-col cols="12" class="py-0">
              <div>
                <p class="subtitle-2 ma-0 pa-0 pb-2">
                  {{ $t("general.Published") }}
                  <span class="pr-6">
                    <v-icon color="green" v-if="item.Published == 1"
                      >far fa-check-square</v-icon
                    >
                    <v-icon color="error" v-else>far fa-square</v-icon>
                  </span>
                </p>
              </div>
            </v-col>
            <!--Date and time-->
            <v-col cols="12" class="py-0">
              <span class="pl-0">{{ item.Created | moment("LL") }}</span>
            </v-col>
            <!--Comments-->
            <v-col cols="12" class="py-0">
              <span class="subtitle-1"
                >{{ $t("yourArticles.card.Seen") }}:
              </span>
              <span class="pl-1 subtitle-1">{{ item.TotalViews }} </span>
              <span> {{ $t("yourArticles.card.Times") }}</span>
              <span> / </span>
              <span class="pl-2 subtitle-1 error--text">{{
                item.TotalComments
              }}</span>
              <!-- style="cursor: pointer;" -->
              <!-- @click="$refs.articleCommentsDialog.openDialog(item)" -->
              <span class="pl-1 subtitle-1">{{
                $t("yourArticles.card.Comments")
              }}</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import messages from "../../modules/lang/main/export";
import ArticleListCommentsDialog from "@/pages/private/components/dialog/articleListCommentsDialog.vue";
// import ArticleLIstSharesDialog from "@/pages/private/components/dialog/articleLIstSharesDialog.vue";
export default {
  i18n: { messages },
  components: {
    ArticleListCommentsDialog,
    // ArticleLIstSharesDialog
  },
  data() {
    return {
      articleCommentsDialog: false,
      articleSharesDialog: false,
      Articles: [],
      ArticleTypes: [],
      SelectedArticleType: "article",
      Content: [],
    };
  },
  computed: {
    filteredArticles() {
      let _articleType = this.SelectedArticleType || this.ArticleTypes[0];
      if (_articleType != this.SelectedArticleType)
        this.SelectedArticleType = _articleType;
      // Here is the variable to get title out of content array, by mapping it
      let _Articles = this.Articles.map((article) => {
        // archive.title shall now be displayed in the original language written
        article.Title = article.Content.find(
          (el) => el.Lang == article.OrgLanguage
        );
        // Here created get moment added into itself
        article.Created = this.$moment(article.Created).format("lll");
        // If not finding any title this way, then go to the first element that match the key title
        if (!article.Title) {
          article.Title = article.Content[0].Title;
        }
        // Else, make title key into the primary array
        else {
          article.Title = article.Title.Title;
        }
        return article;
      });
      return this.Articles;
      // if (!_articleType) {
      //   return this.Articles;
      // }
      // return this.Articles.filter(
      //   article => article.ArticleType == _articleType
      // );
    },
  },

  methods: {
    // Edit the article, by going to the article id
    editArticle(articleId) {
      this.HISTORY_SET({ name: "listarticles" });
      this.$router.push({
        name: "editarticle",
        params: { articleid: articleId },
      });
    },
    ...mapMutations(["HISTORY_SET", "HISTORY_REMOVE"]),
    ...mapActions(["GET_ARTICLES"]),
  },
  mounted() {
    this.GET_ARTICLES().then((resp) => {
      console.log(resp);
      this.Articles = resp.data.Articles;
      this.ArticleTypes = resp.data.ArticleTypes;
      console.log(this.Articles);
    });
  },
};
</script>
